import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import '/usr/mware/jenkins_slave/workspace/visa-dot-com/visa-dot-com_qa/RVCOM_Project/COMPONENT-UI-QA-PUSH-TO-ARTIFACTORY/node_modules/css-loader/dist/runtime/api.js'
import '/usr/mware/jenkins_slave/workspace/visa-dot-com/visa-dot-com_qa/RVCOM_Project/COMPONENT-UI-QA-PUSH-TO-ARTIFACTORY/node_modules/vue-style-loader/lib/addStylesShadow.js'
import '/usr/mware/jenkins_slave/workspace/visa-dot-com/visa-dot-com_qa/RVCOM_Project/COMPONENT-UI-QA-PUSH-TO-ARTIFACTORY/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js'

import dmCalculator from '~root/src/modules/calculator/Calculator.vue?shadow'
window.customElements.define('dm-calculator', wrap(Vue, dmCalculator))